/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="ym-section-base.ts"/>


module Meevo.Plugins.YieldManagementProgram {

    import Service = Meevo.Model.Service;
    import ISelectItem = Meevo.Model.ISelectItem;

    export class YieldManagerStrategyServicesSection extends YmSectionBase {
        public selectedService: Service;
        public serviceCriteria = {};
        public overrideTypeOptions: ISelectItem<ProgramAdjustmentOverrideEnum>[];

        public get overrideType(): typeof ProgramAdjustmentOverrideEnum {
            return ProgramAdjustmentOverrideEnum;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            identityService: Components.Common.IIdentityService,
            noun: Model.NounEnum = null,
            appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            this.overrideTypeOptions = [
                {value: ProgramAdjustmentOverrideEnum.NoOverride, label: 'LABEL_NO_OVERRIDE'},
                {value: ProgramAdjustmentOverrideEnum.DecreasePercent, label: 'LABEL_PERCENT_DECREASE'},
                {value: ProgramAdjustmentOverrideEnum.IncreasePercent, label: 'LABEL_PERCENT_INCREASE'},
                {value: ProgramAdjustmentOverrideEnum.SpecialPrice, label: 'LABEL_SPECIFIC_PRICE'},
            ];
        }

        public selectService() {
            this.model.programServices.push(new ProgramServices({
                serviceId: this.selectedService.id,
                programAdjustmentOverride: ProgramAdjustmentOverrideEnum.NoOverride,
                adjustment: null,
                shortCut: this.selectedService.shortcut,
                displayName: this.selectedService.displayName,
            }));

            this.serviceCriteria = {
                excludeIdList: this.model.programServices.map((service: IProgramServices) => service.serviceId)
            };
            this.selectedService = undefined;
        }

        public removeService(idx: number): void {
            this.model.programServices.splice(idx, 1);

            this.serviceCriteria = {
                excludeIdList: this.model.programServices.map((service: IProgramServices) => service.serviceId)
            };
        }

        sectionModelRetrieved() {
            super.sectionModelRetrieved();

            this.serviceCriteria = {
                excludeIdList: this.model.programServices.map((service: IProgramServices) => service.serviceId)
            };
        }
    }
}
